import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=30a4da0d&scoped=true&"
import script from "./aliPay.vue?vue&type=script&lang=js&"
export * from "./aliPay.vue?vue&type=script&lang=js&"
import style0 from "./aliPay.vue?vue&type=style&index=0&id=30a4da0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4da0d",
  null
  
)

export default component.exports